





















































































































































































































































































































































import Vue from 'vue';
import { Business } from "@/interfaces/business/business";
import { Snackbar } from "@/interfaces/presentation/snackbar";
import { Dialog } from "@/interfaces/presentation/dialog";
import { StoragePlace } from "@/interfaces/place/storagePlace";
import { Keepsake } from "@/interfaces/keepsake/keepsake";

interface DepotWithKeepsakes {
  id: number;
  name: string;
  keepsakes: Array<Keepsake>;
}
import { DepotRepository } from '@/repositories/depotRepository';
import { deleteRequest, ENDPOINTS, get, post, put } from "@/api/mainApi";
import PlaceTransferDialogComponent from "@/components/place/PlaceTransferDialogComponent.vue";

export default Vue.extend({
  components: { PlaceTransferDialogComponent },
  props: {
    business: Object as () => Business,
    autoAddedStoragePlaceState: Boolean
  },
  data() {
    return {
      places: [] as StoragePlace[],
      selected: null as StoragePlace | null,
      loading: false,
      newPlace: {
        name: "",
        description: "",
        business: null
      } as StoragePlace | null,
      newDialog: false,
      fromPlace: null,
      toPlace: null,
      moveKeepsakesDialog: false,
      loadingKeepsakeMove: false,
      depots: [] as DepotWithKeepsakes[],
      loadingDepots: false,
      loadingMoreKeepsakes: false,
      keepsakePageSize: 250,
      nextKeepsakePageIndex: 0,
      hasMoreKeepsakes: false,
      requiredRules: [
        v => !!v || 'Obligatoriskt fält'
      ],
      newFormValid: false,
      moveFormValid: false,
      selectedFormValid: false,
      selectedFormChanged: false,
      depotRepository: new DepotRepository(this),
    }
  },
  computed: {
    fromPlaces() {
      // Only places that have not been selected as a toPlace can be selected
      if (this.toPlace == null) {
        return this.places
      }
      return this.places.filter((place: StoragePlace) => place.id != this.toPlace.id)
    },
    toPlaces() {
      if (this.fromPlace == null) {
        return this.places
      }
      // Only places that have not been selected as a fromPlace can be selected
      return this.places.filter((place: StoragePlace) => place.id != this.fromPlace.id)
    },
    businessName(): string {
      return this.selectedBusiness ? this.selectedBusiness.name : ''
    },
    selectedBusiness: {
      get(): Business {
        return this.business
      },
      set(val: Business) {
        this.$emit('update:business', val)
      }
    }
  },
  watch: {
    selectedBusiness(val: Business) {

      this.places = [];
      this.selected = null;

      if (val && val.id) {
        this.newPlace.business = val;
        this.getStoragePlaces(val.id);
      }
    },
    autoAddedStoragePlaceState(val: StoragePlace) {
      if (val) {
        this.getStoragePlaces(this.selectedBusiness.id)
      }
    }
  },
  mounted() {
    window.addEventListener('focus', this.refreshDepotsOnWindowFocus);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.refreshDepotsOnWindowFocus);
  },
  methods: {
    refreshDepotsOnWindowFocus() {
      // depots open in a new tab, so the list is stale when the user comes back
      if (this.selected && !this.loadingDepots) {
        this.refreshDepotsAndKeepsakeCounts();
      }
    },
    async refreshDepotsAndKeepsakeCounts() {
      await Promise.all([this.fetchDepots(), this.refreshKeepsakeCounts()]);
    },
    async refreshKeepsakeCounts() {
      try {
        const freshPlaces: Array<StoragePlace> = await get(
          ENDPOINTS.BUSINESSES + "/" + this.selectedBusiness.id + "/" + ENDPOINTS.STORAGE_PLACES
        );
        for (const freshPlace of freshPlaces) {
          const place = this.places.find(p => p.id === freshPlace.id);
          if (place) {
            place.keepsakeCount = freshPlace.keepsakeCount;
          }
          if (this.selected && this.selected.id === freshPlace.id) {
            this.selected.keepsakeCount = freshPlace.keepsakeCount;
          }
        }
      } catch (err) {
        console.error('Misslyckades med att uppdatera antal bevakningar:', err);
      }
    },
    selectPlace(place) {
      const selectedPlace = { ...place };
      this.selected = selectedPlace;
      this.$emit('select', selectedPlace);
      this.places.forEach(o => o.active = false);
      selectedPlace.active = true;
      this.selectedFormChanged = false;
      this.fetchDepots();
    },
    async fetchDepots() {
      this.depots = [];
      this.nextKeepsakePageIndex = 0;
      this.hasMoreKeepsakes = false;

      if (!this.selected || !this.selected.id) {
        return;
      }

      this.loadingDepots = true;
      try {
        await this.fetchKeepsakesPage();
      } finally {
        this.loadingDepots = false;
      }
    },
    async loadMoreKeepsakes() {
      this.loadingMoreKeepsakes = true;
      try {
        await this.fetchKeepsakesPage();
      } finally {
        this.loadingMoreKeepsakes = false;
      }
    },
    async fetchKeepsakesPage() {
      try {
        const paginatedResponse = await this.depotRepository.getKeepsakesByStoragePlaceId(
          this.selected.id, this.nextKeepsakePageIndex, this.keepsakePageSize
        );
        const keepsakes = paginatedResponse.data as Keepsake[];

        this.mergeKeepsakesIntoDepots(keepsakes);

        this.nextKeepsakePageIndex = paginatedResponse.currentPage + 1;
        this.hasMoreKeepsakes = this.nextKeepsakePageIndex < paginatedResponse.totalPageCount;
      } catch (err) {
        console.error('Misslyckades med att hämta bevakningar:', err);
      }
    },
    mergeKeepsakesIntoDepots(keepsakes: Keepsake[]) {
      // Group keepsakes by depot, merging into any depots already loaded from earlier pages
      const depotMap = new Map<number, DepotWithKeepsakes>(this.depots.map((depot) => [depot.id, depot]));

      for (const keepsake of keepsakes) {
        if (keepsake.depotKeepsakes) {
          for (const depotKeepsake of keepsake.depotKeepsakes) {
            if (depotKeepsake.depot && !depotKeepsake.extradition && depotKeepsake.depot.status !== 'ARCHIVED') {
              const depotId = depotKeepsake.depot.id;
              let depot = depotMap.get(depotId);
              if (!depot) {
                depot = {
                  id: depotId,
                  name: depotKeepsake.depot.name,
                  keepsakes: []
                };
                depotMap.set(depotId, depot);
              }
              depot.keepsakes.push(keepsake);
            }
          }
        }
      }

      this.depots = Array.from(depotMap.values()).sort((a, b) => a.name.localeCompare(b.name, 'sv'));
    },
    goToDepot(id: number, openInNewTab: boolean = false) {
      if (openInNewTab) {
        const route = this.$router.resolve({ name: 'depotDetails', params: { id } });
        window.open(route.href, '_blank');
      } else {
        this.$router.push({ name: 'depotDetails', params: { id } });
      }
    },
    async getStoragePlaces(businessId) {
      this.loading = true
      get(ENDPOINTS.BUSINESSES + "/" + businessId + "/" + ENDPOINTS.STORAGE_PLACES)
        .then((res: Array<StoragePlace>) => {
          this.places = res;
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false;
        })
    },
    async moveKeepsakes() {

      this.$refs.moveForm.validate();

      if (this.moveFormValid) {

        if (this.fromPlace && this.toPlace) {

          this.loadingKeepsakeMove = true

          put(ENDPOINTS.STORAGE_PLACES + "/" + this.fromPlace.id + "/" + ENDPOINTS.KEEPSAKES + "/" + ENDPOINTS.MOVE + "?toStoragePlaceId=" + this.toPlace.id, {})
            .then((res) => {

              this.fromPlace.keepsakeCount = 0;
              this.toPlace.keepsakeCount += res;

              let snackbar: Snackbar = {
                active: true,
                color: "success",
                text: "Flyttade " + res + " bevakningar från " + this.fromPlace.name + " till " + this.toPlace.name,
                timeout: 8000,
                action: null
              };
              this.$store.commit('setSnackbar', snackbar);
            })
            .catch((err) => {
              console.log(err);

              let snackbar: Snackbar = {
                active: true,
                color: "error",
                text: "Misslyckades med att flyta bevakningar: " + err.data.msg,
                timeout: 8000,
                action: null
              };
              this.$store.commit('setSnackbar', snackbar);

            }).finally(() => {
              this.loadingKeepsakeMove = false;
              this.moveKeepsakesDialog = false;

              this.fromPlace = null;
              this.toPlace = null;
            })
        } else {
          let snackbar: Snackbar = {
            active: true,
            color: "error",
            text: "Du måste välja både till och från",
            timeout: 8000,
            action: null
          };
          this.$store.commit('setSnackbar', snackbar);
        }
      }
    },
    updatePlace(place: StoragePlace) {

      let valid = this.$refs.selectedform.validate()

      if (valid) {

        this.loading = true;
        put(ENDPOINTS.STORAGE_PLACES + "/" + place.id, place)
          .then(res => {
            let snackbar: Snackbar = {
              active: true,
              color: "success",
              text: "Uppdaterade " + place.name,
              timeout: 8000,
              action: null
            };
            this.$store.commit('setSnackbar', snackbar);
            this.selectedFormChanged = false;
            const updatedPlace = this.places.find((foundPlace: StoragePlace) => foundPlace.id === place.id);
            if (!updatedPlace) {
              return;
            }
            updatedPlace.name = place.name;
            updatedPlace.description = place.description;
          })
          .catch(err => {
            console.log(err);
            let snackbar: Snackbar = {
              active: true,
              color: "error",
              text: "Misslyckades med att uppdatera förvaringsplatsen: " + err.data.msg,
              timeout: 10000,
              action: null
            }
            this.$store.commit('setSnackbar', snackbar)
          })
          .finally(() => {
            this.loading = false;
          })
      }
    },
    confirmDeletePlace(place: StoragePlace) {
      let dialog: Dialog = {
        active: true,
        actionBtnText: "Radera förvaringsplats",
        title: "Bekräfta radering",
        text: `Är du säker på att du vill radera ${this.selected.name}?`,
        actionClick: () => {
          this.deletePlace(place)
        },
        closeBtnText: "Stäng"
      }
      this.$store.commit('setDialog', dialog)
    },
    async deletePlace(place: StoragePlace) {

      this.loading = true;

      try {
        let deleted = await deleteRequest(ENDPOINTS.STORAGE_PLACES + "/" + place.id);

        if (deleted) {

          let index = this.places.findIndex((v: StoragePlace) => v.id == place.id)
          if (index !== -1) {
            this.places.splice(index, 1);
            this.selected = null;

            let snackbar: Snackbar = {
              active: true,
              color: "success",
              text: "Raderade förvaringsplatsen",
              timeout: 6000,
              action: null
            }
            this.$store.commit('setSnackbar', snackbar)
          }
        }
      } catch (err) {
        console.log(err);
        let snackbar: Snackbar = {
          active: true,
          color: "error",
          text: "Misslyckades med att radera förvaringsplatsen: " + err.data.msg,
          timeout: 10000,
          action: null
        }
        this.$store.commit('setSnackbar', snackbar)
      } finally {
        this.loading = false;
      }
    },
    addPlace() {

      this.$refs.newForm.validate();

      if (this.newFormValid) {

        this.loading = true;

        post(ENDPOINTS.STORAGE_PLACES, this.newPlace)
          .then((place: StoragePlace) => {
            this.places.push(place);

            let snackbar: Snackbar = {
              active: true,
              color: "success",
              text: "La till " + this.newPlace.name,
              timeout: 8000,
              action: null
            }
            this.$store.commit('setSnackbar', snackbar);

            this.newPlace = {
              name: "",
              description: "",
              business: this.selectedBusiness
            } as StoragePlace

          }).catch(err => {
            console.log(err.data.msg);
            let snackbar: Snackbar = {
              active: true,
              color: "error",
              text: "Misslyckades med att lägga till förvaringsplats: " + err.data.msg,
              timeout: 10000,
              action: null
            }
            this.$store.commit('setSnackbar', snackbar)
          }).finally(() => {
            this.loading = false;
            this.newDialog = false
          })
      }
    },
    handleKeepsakeCountModification(event) {

      let fromPlace: StoragePlace = event.fromPlace;
      let toPlace: StoragePlace = event.toPlace;

      this.places.find(x => x.id === fromPlace.id).keepsakeCount = fromPlace.keepsakeCount;
      this.places.find(x => x.id === toPlace.id).keepsakeCount = toPlace.keepsakeCount;
    }
  }
})
